import apiUrl from "../../../../../utils/settings";

export const sendNewMobileNumberUrl = () => {
  return apiUrl + '/auth/v2/mobile-number';
};